const calculateDailyPrice = (price: number, duration: number): number => {
  const dailyPrice = Math.ceil((price / duration) * 100) / 100
  return dailyPrice
}

export default calculateDailyPrice
